(function(){
  const section = document.getElementById('stats');
  const stats = Array.from(section.querySelectorAll('.stat'));
  let triggered = false;

  function animateNumber(el, end, duration){
    const startTime = performance.now();
    function tick(now){
      let t = Math.min(1, (now - startTime) / duration);
      let eased = t < 0.5 ? 2*t*t : -1+(4-2*t)*t;
      el.textContent = Math.floor(end * eased) + "";
      if(t < 1) requestAnimationFrame(tick);
      else el.textContent = end + "";
    }
    requestAnimationFrame(tick);
  }

  function animateStat(stat){
    const percent = parseInt(stat.dataset.percent, 10);
    const path = stat.querySelector('.progress');
    const number = stat.querySelector('.percent');

    const total = path.getTotalLength();
    const visibleLength = total * (percent / 100);
    const finalOffset = total - visibleLength;  // reversed direction

    // Prepare path
    path.style.transition = "none";
    path.style.strokeDasharray = total;
    path.style.strokeDashoffset = total;  // start fully hidden (reverse)

    path.getBoundingClientRect(); // reflow

    // REVERSE animation (LEFT → RIGHT or CCW)
    path.style.transition = "stroke-dashoffset 1.8s cubic-bezier(.22,.9,.28,1)";
    requestAnimationFrame(() => {
      path.style.strokeDashoffset = finalOffset;
    });

    animateNumber(number, percent, 1800);
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if(entry.isIntersecting && !triggered){
        triggered = true;
        stats.forEach((stat, i) => {
          setTimeout(() => animateStat(stat), i * 200);
        });
      }
    });
  }, { threshold: 0.4 });

  observer.observe(section);
})();